import { TApplicationState } from '../../types/redux';

export const selectAllRecommendationsUrl = (state: TApplicationState) => {
  return state.newbuildingRecommendations.allRecommendationsUrl;
};
